import { render, staticRenderFns } from "./ChoiceOtpSendingDirection.vue?vue&type=template&id=48eb652e&scoped=true&"
import script from "./ChoiceOtpSendingDirection.vue?vue&type=script&lang=js&"
export * from "./ChoiceOtpSendingDirection.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceOtpSendingDirection.vue?vue&type=style&index=0&id=48eb652e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eb652e",
  null
  
)

export default component.exports